import _ from 'lodash';
import { Param } from "../Param";
import { Facet } from "./Facet";

export class FacetGroup {
	constructor({
		id,
		label,
		facets = [],
		subgroups = []
	}) {
		this.type = 'FacetGroup';
		this.id = id;
		this.label = label;
		this.facets = facets;
		this.subgroups = subgroups
	}


	addGroup(facetGroup) {
		FacetGroup._addOrReplaceById(this.subgroups, facetGroup);
	}

	getGroup(id, deep = false) {
		var group = _.find(this.subgroups, { id: id });

		if (!group && deep) {
			_.each(this.subgroups, g => {
				group = g.getGroup(id, true);
			});
		}

		return group;
	}

	removeGroup(id, deep = false) {
		var group = this.getGroup(id);

		if (!group && deep) {
			_.each(this.subgroups, g => {
				g.removeGroup(id, true);
			})

		} else if (group) {
			_.remove(this.subgroups, { id: id });
		}

	}

	addFacet(facet) {
		FacetGroup._addOrReplaceById(this.facets, facet);
	}

	getFacet(id, deep = false) {
		var facet = _.find(this.facets, { id: id });
		if (!facet && deep) {
			_.some(this.subgroups, g => {
				facet = g.getFacet(id, true);
				return facet !== undefined;
			});
		}

		return facet;
	}

	getSelectedFacets(deep = false) {
		var selectedFacets = _.where(this.facets, { selected: true });
		if (deep) {
			_.each(this.subgroups, group => {
				selectedFacets = selectedFacets.concat(group.getSelectedFacets(true));
			});
		}

		return selectedFacets;
	}

	removeFacet(id) {
		_.remove(this.facets, { id: id });
	}

	selectFacet(id, deep = false) {
		let facet = this.getFacet(id, deep);
		if (facet) {
			facet.selected = true;
		}
	}

	deselectFacet(id, deep = false) {
		let facet = this.getFacet(id, deep);
		if (facet) {
			facet.selected = false;
		}
	}

	toggleFacet(id, deep) {
		let facet = this.getFacet(id, deep);
		if (facet) {
			facet.selected = !facet.selected;
		}
	}

	toParam() {
		return new Param({ id: this.id, value: this._facetValues() });
	}

	_facetValues(deep = true) {
		return _.map(this.getSelectedFacets(deep), f => {
			return f.id;
		}).join(',');
	}

	static buildFromJson(rawGroup) {
		var id = rawGroup.id;
		let label = rawGroup.label;
		let facets = [];
		let subgroups = [];
		_.each(rawGroup.values, value => {
			// check if nested group or raw facet
			// if 'values' is either not a property or a null value, it is a facet
			if (value.hasOwnProperty('values') && value.values !== null) {
				subgroups.push(FacetGroup.buildFromJson(value));
			} else {
				facets.push(Facet.buildFromJson(value, id))
			}
		});

		return new FacetGroup({
			id: id,
			label: label,
			facets: facets,
			subgroups: subgroups
		});

	}

	static _addOrReplaceById(list, thing) {
		var match = _.find(list, { id: thing.id });
		if (match) {
			let index = _.indexOf(list, match);
			list.splice(index, 1, thing);
		} else {
			list.push(thing);
		}
	}


}